import { DELEGATION_PAGINATION_TYPES } from '../../constants/actionTypes/delegationActionTypes';

export const INITIAL_STATE = {
    count: 0
};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case DELEGATION_PAGINATION_TYPES.SET_COUNT: {
            return { ...state, count: action.count };
        }

        default:
            return state;
    }
};